
<div>
  <span class="title">Overall Summary</span>
  <loader class="loader" size="small" *ngIf="displayLoader"></loader>
  <h3 class="no-data-text" *ngIf="!displayLoader && summaryData.length == 0">(No Data Found)</h3>
</div>
<div class="subtitle-section" *ngIf="!displayLoader && summaryData.length > 0">
  <p class="subtitle">Showing percentage of racks washed with no alarms triggered</p>
  <table class="table-legend">
    <tr>
      <td class="red-rack">Below 76%</td>
      <td class="yellow-rack">Between 76% and 95%</td>
      <td class="green-rack">Over 95%</td>
    </tr>
  </table>
</div>
<div class="table-container" *ngIf="!displayLoader && summaryData.length > 0">
  <table>
    <tr>
      <th>Metrics</th>
      <th *ngFor="let data of summaryData">{{ convertPeriodToDate(data.Period) }}</th>
    </tr>
    <tr>
      <td> Average Racks per Day </td>
      <td *ngFor="let data of summaryData">
        {{ data.AvgRacksPerDay }}
      </td>
    </tr>
    <tr>
      <td> Rinse Temp </td>
      <td *ngFor="let data of summaryData" [ngClass]="handleMetricPercentage(data.AvgRinseTemp)">
        {{ data.AvgRinseTemp }}%
      </td>
    </tr>
    <tr>
      <td> Wash Temp </td>
      <td *ngFor="let data of summaryData" [ngClass]="handleMetricPercentage(data.AvgWashTemp)">
        {{ data.AvgWashTemp }}%
      </td>
    </tr>
    <tr>
      <td> Detergent </td>
      <td *ngFor="let data of summaryData" [ngClass]="handleMetricPercentage(data.AvgDetergent)">
        {{ data.AvgDetergent }}%
      </td>
    </tr>
    <tr>
      <td> Rinse Additive </td>
      <td *ngFor="let data of summaryData" [ngClass]="handleMetricPercentage(data.AvgRinseAdditive)">
        {{ data.AvgRinseAdditive }}%
      </td>
    </tr>
    <tr>
      <td> Sanitizer </td>
      <td *ngFor="let data of summaryData" [ngClass]="handleMetricPercentage(data.AvgSanitizer)">
        {{ data.AvgSanitizer }}%
      </td>
    </tr>
    <tr>
      <td> Wash Tank Change Out </td>
      <td *ngFor="let data of summaryData" [ngClass]="handleMetricPercentage(data.AvgWashTankChangeOut)">
        {{ data.AvgWashTankChangeOut }}%
      </td>
    </tr>
  </table>
</div>
